export default "__VITE_ASSET__CDTWaoR5__"